import type { DeleteInternalAuditReportsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteInternalAuditReportsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useDeleteInternalAuditReports = createMutationHook({
  name: 'deleteInternalAuditReports',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.internalAuditReport.delete.mutationOptions({ onSuccess }),
  mapInput: (ids: string[]) => ({ Ids: ids }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditReport.register.queryKey(),
    trpc.frontend.internalAuditReport.internalAuditReportCount.queryKey(),
    trpc.frontend.internalAuditReport.internalAuditReportsByOriginatingItemId.queryKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): DeleteInternalAuditReportsMutation => ({
    delete_internal_audit_report: {
      __typename: 'internal_audit_report_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: DeleteInternalAuditReportsDocument,
  graphqlVariables: (ids: string[]) => ({ Ids: ids }),
  evictFields: ['internal_audit_report', 'internal_audit_report_aggregate'],
});
